export default {
  facebook: 'https://www.facebook.com/pixionco',
  instagram: 'https://www.instagram.com/pixion.co/',
  linkedIn: 'https://www.linkedin.com/company/pixionco',
  pangea: 'https://pangea.ai/agencies/pixion',
}
